import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { FeaturesData } from '@fcp/lib-ui';
import { ShowcaseFeaturesContainerService } from './showcase-features-container.service';

@Component({
  selector: 'fcp-showcase-features-container',
  template: `
    <fcp-showcase-features
      [features]="features | async"
      (wasClicked)="wasClicked.emit($event)"
      (wasClickedScrollToElement)="wasClickedScrollToElement.emit($event)"
    >
    </fcp-showcase-features>
  `
})
export class ShowcaseFeaturesContainerComponent implements OnInit {
  @Input() private id: string;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasClickedScrollToElement: EventEmitter<
    any
  > = new EventEmitter();
  public features: Observable<FeaturesData>;
  constructor(
    private showcaseFeaturesContainerService: ShowcaseFeaturesContainerService
  ) {}

  ngOnInit() {
    this.features = this.showcaseFeaturesContainerService.getVantagens(this.id);
  }
}
